import React from 'react';
import './InduceClickText.scss';
function InduceClickText(props) {
    const renderText = () => {
        if(props.value === "ko"){
            return  <div><span>템플릿</span>을 클릭하고 <span>Drag&Drop</span>으로 영상을 만들어보세요</div>
        }
        if(props.value === "jp"){
            return  <div><span>テンプレート</span>を選択して <span>Drag&Drop</span>で動画を作成してください</div>
        }
        else {
            return <div>Choose a <span>template</span> you like, and <span>Drag&Drop</span> to create a video.</div>
        }
    }
    return (
        <div className="InduceClickText-container">
            {renderText()}
        </div>
    );
}

export default InduceClickText;